var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.unitPlans),function(unitPlan,idx){return _c('md-list-item',{key:idx},[_c('router-link',{attrs:{"to":{name: 'unit-plan', params: {id:unitPlan.id}}}},[_vm._v(_vm._s(unitPlan.name)+" ("+_vm._s(_vm.formatDate(unitPlan.start_date))+")")])],1)}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bb3d41","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnitPlanNavigation.vue
// module id = null
// module chunks = 